import React from 'react'
import { WebNextComponents } from '@izettle/public-site-components/dist/web-next'

const Component = ({ content }: any) => {
  if (typeof WebNextComponents[content.component] !== 'undefined') {
    const Component = WebNextComponents[content.component]
    return <Component key={content._uid} {...content} />
  }
  return <span>not found {content.component}</span>
}

export default Component
